$(document).ready(function () {
    $(".facet-selection").click(FacetSelection);
    $(".menu-reset").click(function () { window.location.href = window.location.href.split('?')[0]; });
    $("#keyword-search").keypress(function(e) {
        var params = new URLSearchParams(window.location.search);
        if (e.key !== 'Enter' || (this.value === '' && params.get('textSearch') === '')) {
            return;
        }
        return FacetSelection(e);
    });
    $(".keyword-search-trigger").click(function () {
        return FacetSelection();
    });

    $('.pagination').on('click', 'a.js-page', function () {
        var pageNumber = $(this).data("page");
        filterItems(pageNumber);
    });

    var filterItems = function (gotoPage) {
        var urlParams = new URLSearchParams(window.location.search);
        var filterText = urlParams.get("filter");
        var keywordText = urlParams.get("textSearch");
        var pageUrl = [location.protocol, '//', location.host, location.pathname, '?page=', gotoPage,
            filterText ? "&filter=" + filterText : "", keywordText ? "&textSearch=" + keywordText : ""].join('');
        history.replaceState({}, null, pageUrl);
        window.location.reload();
    };
});

function FacetSelection() {
    $(this).closest("li").find(".facet-selection").prop("checked", this.checked);
    var querystring = "";
    $(".facet-selection:checked").each(function () {
        if (querystring == "") {
            querystring += $(this).val();
        }
        else {
            querystring += "," + $(this).val();
        }
    });

    var searchText = $('#keyword-search').val();
    searchText = encodeURIComponent(searchText);

    window.location.href = "?filter=" + querystring + "&textSearch=" + searchText + "&page=1";
}